import React, { ReactElement } from "react";
import { trackEventNext } from "@kunduz/utility-analytics";
import { ImageBanner } from "@kunduz/ui-components";
import { type IContent } from "@kunduz/data-access-cms-api";

export const ImageBannerWithContext = (props: Props): ReactElement => {
  const handleClick = () => {
    trackEventNext({
      event: "Image Banner Clicked",
    });
  };

  return (
    <ImageBanner
      desktopImageUrl={props.data.scaled_image}
      mobileImageUrl={props.data.full_image}
      href={props.data.url}
      target={props.data.target}
      onClick={handleClick}
    />
  );
};

interface Props {
  data: IContent.ImageBannerComponentData;
}
